import { Injectable } from '@angular/core';
import { RouteFormDateSelectorService } from '../components/route-form-date-selector/services/route-form-date-selector.service';
import { RouteFormMoreOptionsService } from '../components/route-form-more-options/services/route-form-more-options.service';
import { RouteFormOptions } from '../models/routeFormOptions.model';

@Injectable({
  providedIn: 'root'
})
export class RouteFormOptionsService {

  constructor(private dateSelectorService: RouteFormDateSelectorService, private moreOptionsService: RouteFormMoreOptionsService) { }

  public getOptionsForRequest(): RouteFormOptions {
    return {
      ...this.dateSelectorService.getDataForRequest(),
      ...this.moreOptionsService.getDataForRequest(),
    }
  }

  public setOptionsFromUrlParams(params: RouteFormOptions) {
    this.dateSelectorService.setDateFromUrlParams(params);
    this.moreOptionsService.setMoreOptionsFromUrlParams(params);
  }
}
